
import React from "react";
import "./AboutInstitute.css";

const AboutInstitute = () => {
  return (
    <div className="about-institute-container fade-in">

      
      <section className="about-hero-section slide-up">
        <h2>About Our Institute</h2>
        <hr className="heading-separator-line" />
        <p className="hero-subtitle">
          Empowering rural students with world-class pharmaceutical education.
        </p>
      </section>

     
      <section className="about-content">

        <div className="about-left slide-left">
          <p>
            Sumatidevi Tompe Institute of Pharmaceutical Science and Research is a prestigious educational institution located in Chandur Bazar, Amravati. Our mission is to deliver exceptional pharmacy education to rural regions and create pathways that connect rural learning with urban standards.
          </p>

          <p>
            Our modern campus features advanced laboratories, smart classrooms, and a rich library with books, journals, e-resources, and databases essential for pharmaceutical studies. Highly qualified faculty members lead with experience, dedication, and a passion for student development.
          </p>
        </div>

        
        <div className="about-right slide-right">
          <p>
            The institute also provides digital learning support, including a high-speed Wi-Fi campus enabling uninterrupted academic research. Practical learning is enhanced through our state-of-the-art laboratory setup equipped with modern instruments for hands-on training.
          </p>

          <p>
            Our 10,000 sq ft auditorium is an architectural highlight — equipped with premium audio-visual systems and designed for seminars, presentations, ceremonies, and cultural events.
          </p>
        </div>
      </section>

      <section className="highlight-block zoom-in">
        <p>
          “At STIPSR, we believe education should be accessible, inclusive, and transformative. Our goal is to shape future pharmacy professionals who will impact global healthcare.”
        </p>
      </section>
    </div>
  );
};

export default AboutInstitute;
